import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscriber } from '@opentok/client';
import { UtilsService } from '../../../../../../services/utils/utils.service';

@Component({
  standalone: true,
  imports: [],
  selector: 'sas-capture-photo',
  templateUrl: './capture-photo.component.html',
  styleUrls: ['./capture-photo.component.scss']
})
/**
 * Componente para la captura de pantalla
 */
export class CapturePhotoComponent {
  /**
   *  Subscripción a la sesión para mostrar vídeo y audio de la videoconferencia del participante.
   */
  @Input() subscriber!: Subscriber;
  /**
   * Nombre del participante.
   */
  @Input() attendantName!: string;
  /**
   * Variable para obtener el estado del video del participante.
   */
  @Input() hasVideo?: boolean;

  constructor(
    private readonly utilsService: UtilsService,
    private readonly translateService: TranslateService
  ){}

  /**
   * Método que ejecuta la captura de pantalla
   */
  capturePhoto() {
    // const link = document.createElement('a');
    // link.href = 'data:image/jpg;base64,' + this.subscriber.getImgData();
    // link.download = (this.attendantName ? this.attendantName : 'image') + ' - capture.jpg';
    // link.click();
    //Se obtiene la captura de la subscripción de las publicaciones
    const arrayImage = this.subscriber.getImgData();
    console.log('capturePhoto subscriber.getImgData (' + this.utilsService.getTodayWithHour() +') arrayImage:', arrayImage);
    const fileName = this.translateService.instant('CAPTURE_IMAGE');
    //Se abre la imagen
    if(arrayImage)
      this.utilsService.openFile(arrayImage, fileName, 'image/jpg');
  }
}
